import type { OverridedMixpanel } from 'mixpanel-browser';

/**
 * Set once by `initAnalytics`, so every other function in this package acts on
 * the same initialised instance (same persistence config, same `before_track`
 * hooks) instead of racing a separate `import('mixpanel-browser')`.
 */
let client: Promise<OverridedMixpanel | undefined> | undefined;

export const setClient = (promise: Promise<OverridedMixpanel | undefined>) => {
  client = promise;
};

/**
 * Runs `fn` against the initialised SDK once it loads. No-ops when analytics
 * was never started — no token, SSR, or a failed chunk load — so callers never
 * need to guard against an absent client themselves.
 */
export const withClient = (fn: (mixpanel: OverridedMixpanel) => void): void => {
  void client?.then((mixpanel) => {
    if (mixpanel) fn(mixpanel);
  });
};
